import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    get question() { return translateInterfaceText("O que é o Programa de Parcerias Host VSL?"); },
    get answer() { return translateInterfaceText("É um programa onde você indica a Host VSL e recebe 20% de comissão recorrente sobre os planos ativados pelos clientes que você indicar."); }
  },
  {
    get question() { return translateInterfaceText("Como funciona o pagamento da comissão?"); },
    get answer() { return translateInterfaceText("As comissões são pagas mensalmente via PIX ou transferência bancária, desde que o cliente indicado mantenha o plano ativo."); }
  },
  {
    get question() { return translateInterfaceText("Qual o valor das comissões?"); },
    get answer() { return translateInterfaceText("Você recebe 20% de comissão recorrente sobre o valor do plano ativo. Por exemplo: se seu indicado possui o plano de R$ 147/mês, você recebe R$ 29,40 todo mês."); }
  },
  {
    get question() { return translateInterfaceText("Posso ser parceiro como pessoa física?"); },
    get answer() { return translateInterfaceText("Sim! O programa aceita tanto pessoas físicas quanto jurídicas. Basta ter uma conta bancária ou chave PIX para receber os pagamentos."); }
  },
  {
    get question() { return translateInterfaceText("Meus clientes têm desconto?"); },
    get answer() { return translateInterfaceText("Sim! Como parceiro, você pode oferecer vantagens exclusivas aos seus indicados, como bônus especiais e materiais complementares."); }
  },
  {
    get question() { return translateInterfaceText("Há limite de indicações?"); },
    get answer() { return translateInterfaceText("Não! Você pode fazer quantas indicações quiser. Quanto mais clientes ativos você tiver, maior será sua comissão recorrente mensal."); }
  },
  {
    get question() { return translateInterfaceText("Como acompanho meus resultados?"); },
    get answer() { return translateInterfaceText("Você terá acesso a um painel exclusivo onde poderá acompanhar suas indicações, conversões, comissões e pagamentos em tempo real."); }
  },
  {
    get question() { return translateInterfaceText("Preciso pagar para participar?"); },
    get answer() { return translateInterfaceText("Não! A participação no programa é 100% gratuita. Você só precisa se cadastrar e começar a indicar."); }
  }
];

export function ReferralFAQ() {
  useLanguage();
  return (
    <section className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl lg:text-2xl font-bold text-foreground">
          {translateInterfaceText("Perguntas Frequentes")}</h3>
        <p className="text-muted-foreground">
          {translateInterfaceText("Tire suas dúvidas sobre o programa")}</p>
      </div>
      
      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
